/**
 * Navbar.jsx
 *
 * Barre de navigation avec :
 * - Logo et nom stylisé "Altered-checker"
 * - Menu burger (Drawer Ant Design)
 * - Toggle mode nuit/jour
 * - Navigation responsive
 */

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout, Drawer, Menu, Button, Space, Badge } from "antd";
import { MenuOutlined, SunOutlined, MoonOutlined } from "@ant-design/icons";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";

const { Header } = Layout;

export default function Navbar() {
    const { token, logout } = useAuth();
    const { isDarkMode, toggleTheme } = useTheme();
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);

    /**
     * Élément du menu - cliquable et ferme le drawer
     */
    const menuItems = [
        {
            key: "home",
            label: <Link to="/" onClick={() => setDrawerOpen(false)}>Accueil</Link>,
        },
        {
            key: "cards",
            label: <Link to="/search" onClick={() => setDrawerOpen(false)}>Toutes les cartes</Link>,
        },
        {
            key: "today",
            label: <Link to="/today-sales" onClick={() => setDrawerOpen(false)}>Cartes du jour</Link>,
        },
        ...(token
            ? [
                {
                    key: "favorites",
                    label: <Link to="/favorites" onClick={() => setDrawerOpen(false)}>Favoris</Link>,
                },
                {
                    key: "searches",
                    label: <Link to="/saved-searches" onClick={() => setDrawerOpen(false)}>Mes recherches</Link>,
                },
                {
                    key: "settings",
                    label: <Link to="/settings" onClick={() => setDrawerOpen(false)}>⚙️ Paramètres</Link>,
                },
                {
                    key: "logout",
                    label: (
                        <button
                            onClick={() => {
                                logout();
                                setDrawerOpen(false);
                                navigate("/");
                            }}
                            style={{ color: "inherit", background: "none", border: "none", cursor: "pointer" }}
                        >
                            Déconnexion
                        </button>
                    ),
                },
            ]
            : [
                {
                    key: "login",
                    label: <Link to="/login" onClick={() => setDrawerOpen(false)}>Connexion</Link>,
                },
                {
                    key: "register",
                    label: <Link to="/register" onClick={() => setDrawerOpen(false)}>Inscription</Link>,
                },
            ]),
    ];

    return (
        <Header
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 24px",
                background: isDarkMode ? "#141414" : "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            }}
        >
            {/* Logo et nom */}
            <Link
                to="/"
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    textDecoration: "none",
                    color: "inherit",
                }}
            >
                <img
                    src="/logo.png"
                    alt="Altered-checker logo"
                    style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "8px",
                        objectFit: "contain",
                        background: isDarkMode ? "#1f1f1f" : "#f5f5f5",
                        padding: "4px"
                    }}
                />
                <span
                    style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        background: "linear-gradient(135deg, #177ddc 0%, #00d4ff 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                    }}
                >
                    Altered-checker
                </span>
            </Link>

            {/* Contrôles à droite */}
            <Space size="middle">
                {/* Toggle mode nuit/jour */}
                <Button
                    type="text"
                    icon={isDarkMode ? <SunOutlined /> : <MoonOutlined />}
                    onClick={toggleTheme}
                    size="large"
                    title={isDarkMode ? "Mode clair" : "Mode sombre"}
                />

                {/* Menu burger */}
                <Button
                    type="text"
                    icon={<MenuOutlined />}
                    onClick={() => setDrawerOpen(true)}
                    size="large"
                />
            </Space>

            {/* Drawer (menu coulissant) */}
            <Drawer
                title="Menu"
                placement="right"
                onClose={() => setDrawerOpen(false)}
                open={drawerOpen}
            >
                <Menu
                    items={menuItems}
                    mode="vertical"
                    onClick={() => setDrawerOpen(false)}
                />
            </Drawer>
        </Header>
    );
}